import { render, staticRenderFns } from "./balanceRecord.vue?vue&type=template&id=189a4e99&scoped=true&"
import script from "./balanceRecord.vue?vue&type=script&lang=js&"
export * from "./balanceRecord.vue?vue&type=script&lang=js&"
import style0 from "./balanceRecord.vue?vue&type=style&index=0&id=189a4e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a4e99",
  null
  
)

export default component.exports